let toast;
let content;
let timeout;
const init = (delay = 3000) => {
    toast = document.getElementById('toast');
    timeout = delay;
    if (!toast) {
        toast = document.createElement('div');
        toast.setAttribute('id', 'toast');
        toast.className = 'toast';
        content = document.createElement('div');
        content.className = 'toast__content';
        toast.appendChild(content);
        document.body.appendChild(toast);
    }
};
const show = (message, type = '') => {
    content.innerHTML = message;
    if (type === 'error') {
        toast.classList.add('toast--error');
    }
    else {
        toast.classList.remove('toast--error');
    }
    toast.classList.add('toast--show');
    setTimeout(() => {
        toast.classList.remove('toast--error');
        toast.classList.remove('toast--show');
    }, timeout);
};
export default {
    init,
    show,
};
